import React from "react";
import AmountWidget from "./AmountWidget";
import { totalSupply } from "../common/lumens.js";

export default class TotalCoins extends AmountWidget {
  componentDidMount() {
    this.timerID = setInterval(() => this.updateAmount(), 60 * 60 * 1000);
    this.updateAmount();
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  updateAmount() {
    totalSupply().then((amount) => {
      let code = "XBN";
      this.setState({ amount, code, loading: false });
    });
  }

  renderName() {
    return (
      <div>
        <span>Total Supply</span>
      </div>
    );
  }
}
